import AccessTokenResourceModel from '../../generated/types/model/resource/AccessTokenResourceModel';

export default class AccessTokenResourceViewModel extends AccessTokenResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
